import { Component } from '@angular/core';
import { UploadFormComponent } from '../upload-form/upload-form.component';
import { NavbarComponent } from "../navbar/navbar.component";
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule, PlatformLocation } from '@angular/common';
import { LoaderComponent } from "../../utility components/loader/loader.component";
import { ChatbotComponent } from '../chatBot/chatBot.component';
import { PopUpComponent } from "../pop-up/pop-up.component";
// import { PopUpComponent_1 as PopUpComponent } from "../pop-up/pop-up.component";


@Component({
    selector: 'app-home',
    imports: [UploadFormComponent, NavbarComponent, MatCardModule,
    MatButtonModule, LoaderComponent, CommonModule, ChatbotComponent, PopUpComponent],
    templateUrl: './home.component.html',
    styleUrl: './home.component.css',
    standalone: true
})
export class HomeComponent {

  isPopupOpen = false;
  isLoading: boolean = false;
  fileFromPopup: File | null = null;


  constructor(private platformLocation:PlatformLocation) {
      history.pushState(null, '', location.href);
      this.platformLocation.onPopState(() => {
      history.pushState(null, '', location.href);
  })
  }


  openPopup() {
    this.isPopupOpen = true;
  }

  closePopup() {
    this.isPopupOpen = false;
    console.log('close popup event received',this.isPopupOpen);
  }

  onLoadingStateChange(isLoading: boolean): void {
    this.isLoading = isLoading;
  }
  handleProcessedFile(file: File) {
    this.fileFromPopup=file;
    console.log("Received processed file:", file);
    // You can now send this file to an API or process it further
  }

}
